import { render } from "./ClientPayments.vue?vue&type=template&id=26b90412"
import script from "./ClientPayments.vue?vue&type=script&lang=js"
export * from "./ClientPayments.vue?vue&type=script&lang=js"

import "./ClientPayments.vue?vue&type=style&index=0&id=26b90412&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__